export default "__VITE_ASSET__B1fjnJa3__"